// src/subscription/calculators.ts
var RECURRING_FREQUENCIES = [
  "monthly",
  "quarterly",
  "semi-annually",
  "annually"
];
function isRecurringBillingFrequency(value) {
  return RECURRING_FREQUENCIES.includes(value);
}
function getMonthIncrement(billingFrequency) {
  if (billingFrequency === "quarterly") return 3;
  if (billingFrequency === "semi-annually") return 6;
  if (billingFrequency === "annually") return 12;
  return 1;
}
var DEFAULT_CALENDAR = "utc";
function resolveCalendar(options) {
  return options.calendar ?? DEFAULT_CALENDAR;
}
function addMonthsClamped(date, months) {
  const result = new Date(date);
  const originalDay = result.getDate();
  result.setDate(1);
  result.setMonth(result.getMonth() + months);
  const daysInTarget = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate();
  result.setDate(Math.min(originalDay, daysInTarget));
  return result;
}
function addMonthsClampedUtc(date, months) {
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + months;
  const day = date.getUTCDate();
  const daysInTarget = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  return new Date(Date.UTC(year, month, Math.min(day, daysInTarget), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds()));
}
function stepMonths(date, months, calendar) {
  return calendar === "utc" ? addMonthsClampedUtc(date, months) : addMonthsClamped(date, months);
}
function getBillingCycleDates(startDate, currentDate, billingFrequency = "monthly", options = {}) {
  const monthIncrement = getMonthIncrement(billingFrequency);
  const calendar = resolveCalendar(options);
  let cycleStart = new Date(startDate);
  while (true) {
    const nextCycleStart2 = stepMonths(cycleStart, monthIncrement, calendar);
    if (currentDate < nextCycleStart2) break;
    cycleStart = nextCycleStart2;
  }
  const nextCycleStart = stepMonths(cycleStart, monthIncrement, calendar);
  const cycleEnd = new Date(nextCycleStart);
  if (calendar === "utc") cycleEnd.setUTCDate(cycleEnd.getUTCDate() - 1);
  else cycleEnd.setDate(cycleEnd.getDate() - 1);
  return { cycleStart, cycleEnd };
}
function calculateUsagePercentage(used, max) {
  if (max === null || max === 0) {
    return null;
  }
  return Math.min(100, used / max * 100);
}
function getSubscriptionExpirationDate(subscription) {
  if (subscription.type === "none") {
    return null;
  }
  if (subscription.type === "membership") {
    return subscription.endDate;
  }
  if (subscription.type === "pass") {
    return subscription.expirationDate;
  }
  return null;
}
function getSubscriptionStatus(subscription, currentDate = /* @__PURE__ */ new Date()) {
  if (subscription.type === "none") {
    return "none";
  }
  if (subscription.type === "membership") {
    if (subscription.ended) {
      return "cancelled";
    }
    if (subscription.endDate && subscription.endDate < currentDate) {
      return "expired";
    }
    return "active";
  }
  if (subscription.type === "pass") {
    return subscription.status;
  }
  return "none";
}
function getNextRenewalDate(startDate, currentDate, billingFrequency = "monthly", options = {}) {
  const { cycleEnd } = getBillingCycleDates(startDate, currentDate, billingFrequency, options);
  const renewalDate = new Date(cycleEnd);
  if (resolveCalendar(options) === "utc") renewalDate.setUTCDate(renewalDate.getUTCDate() + 1);
  else renewalDate.setDate(renewalDate.getDate() + 1);
  return renewalDate;
}
function getDaysUntilExpiration(expirationDate, currentDate = /* @__PURE__ */ new Date()) {
  const diffMs = expirationDate.getTime() - currentDate.getTime();
  return Math.ceil(diffMs / (1e3 * 60 * 60 * 24));
}
function isApproachingLimit(used, limit) {
  if (limit === null) {
    return false;
  }
  const percentage = calculateUsagePercentage(used, limit);
  return percentage !== null && percentage >= 80;
}

export { addMonthsClamped, addMonthsClampedUtc, calculateUsagePercentage, getBillingCycleDates, getDaysUntilExpiration, getNextRenewalDate, getSubscriptionExpirationDate, getSubscriptionStatus, isApproachingLimit, isRecurringBillingFrequency };
//# sourceMappingURL=calculators.js.map
//# sourceMappingURL=calculators.js.map